import { combineReducers } from 'redux';
import { Map } from 'immutable';
import data from './data/reducer';
import core from './core';

const MIDDLEWARE_INITIAL_STATE = new Map({
    general: new Map({ state: null })
});

function middleware(state = MIDDLEWARE_INITIAL_STATE, action) {
    switch (action.type) {
        case 'FHEPOOL__MIDDLEWARE_SET_CONNEXION_STATE':
            return core.setMiddlewareConnectionState(state, action.state);
    }
    return state;
}

const GROUPID_INITIAL_STATE = new Map({
    groupId: null,
    assigneeIds: null
});

function gitlabApi(state = GROUPID_INITIAL_STATE, action) {
    switch (action.type) {
        case 'FHEPOOL_GIT__SET_GROUPID':
            return core.setGroupId(state, action.groupId);
        case 'FHEPOOL_GIT__SET_ASSIGNEEIDS':
            return core.setAssigneeIds(state, action.assigneeIds);
    }
    return state;
}

export default combineReducers({
    gitlabApi,
    middleware,
    data
});



// WEBPACK FOOTER //
// ./environments/fhepool/reducer.js